import { Button, Fade, Grid2 as Grid, Menu, MenuItem, Typography, Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText, CircularProgress, Link, Divider, Fab, Box, TextField, InputLabel } from "@mui/material";
import { createStyles, Theme } from '@mui/material/styles';
import { WithStyles, withStyles } from '@mui/styles';
import { Autorenew, ArrowDropDown as ArrowDropDownIcon } from '@mui/icons-material';
import * as React from "react";
import { connect } from "react-redux";
import { AjaxError } from "rxjs/ajax";
import { firstValueFrom } from "rxjs";
import { SeedTime } from "../../Configuration/Setting";
import idssStyle from "../../Configuration/SharedStyling";
import { genericMapStateToProps, IGenericUserProps } from "../../DataClasses/GenericUser";
import { ISelectedSubmissions } from "../../DataClasses/SubmissionData";
import SharedUtility from "../../Utilities/SharedUtility";
import SubmissionsService from "../Services/SubmissionsService";
import { Redirect } from "react-router-dom";
import Select from "react-select";
import ProcessingDisplay from "../Shared/ProcessingDisplay";
import SharedMaterialReactTable, { ISharedTableColumn } from "../Shared/MaterialReactTable";
import LoadingDataTable from "../Shared/LoadingDataTable";

const styles = (theme: Theme) => createStyles({
    ...idssStyle(theme)
});

interface ISubmissionAdministrationState {
    isLoading: boolean,
    isProcessing: boolean,
    openDialog: boolean;
    dialogConfirmationText: string,
    selectedSubmissions: ISelectedSubmissions[],
    rowsSelected: number[],
    submissionData: any[],
    anchorEl: HTMLElement | null,
    selectedAction: string,
    statusMessage: string,
    redirect: boolean,
    openBulkDialog: boolean,
    bulkSubmissionIds: string,
    bulkSelectedSubType: any,
    isBulkReprocessing: boolean,
    showBulkReprocessSuccess: boolean
}

type IStylesProps = WithStyles<typeof styles>;
const ITEM_HEIGHT: number = 48;
const HEDIS = "HEDIS";
const HOS = "HOS";
const CAHPS = "CAHPS";
const REPROCESS = "Reprocess";
const ROLLBACK = "Rollback";
const UNATTEST = "UnAttest";
const UNMARKFINAL = "UnMarkFinal";
const UNSUBMIT = "Unsubmit";
let distinctComponents = [];
let distinctStages = [];
let distinctSubIds = [];

const SubmissionActions = [
    { "Action": REPROCESS },
    { "Action": ROLLBACK },
    { "Action": UNATTEST },
    { "Action": UNMARKFINAL },
    { "Action": UNSUBMIT },
];

// VIEW
class SubmissionAdministrationView extends React.Component<
    IGenericUserProps & IStylesProps,
    ISubmissionAdministrationState
> {
    constructor(props) {
        super(props);

        this.state =
        {
            isLoading: true,
            openDialog: false,
            dialogConfirmationText: '',
            isProcessing: false,
            selectedSubmissions: [],
            rowsSelected: [],
            submissionData: [],
            statusMessage: '',
            anchorEl: null,
            selectedAction: "Available Actions",
            redirect: false,
            openBulkDialog: false,
            bulkSubmissionIds: '',
            bulkSelectedSubType: '',
            isBulkReprocessing: false,
            showBulkReprocessSuccess: false
        };
    }

    private getSubmissionSelectionState = (): Record<string, boolean> => {
        const selection: Record<string, boolean> = {};
        this.state.selectedSubmissions.forEach(selectedSub => {
            if (selectedSub.submissionId) {
                selection[selectedSub.submissionId.toString()] = true;
            }
        });
        return selection;
    };

    public async componentDidMount() {
        this.refreshModel();
    }

    private redirectToErrorPage() {
        return <Redirect to='/errorpage' />;
    }

    private setRedirectState() {
        this.setState({ redirect: true });
    }

    private getSubmissionColumns = (): ISharedTableColumn<any>[] => [
        {
            accessorKey: '0' as any, // Org ID
            header: 'Org ID',
            enableSorting: true,
            enableFiltering: true,
            filterVariant: 'multi-select',
        },
        {
            accessorKey: '1' as any, // Sub ID
            header: 'Sub ID',
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: '2' as any, // Org Name
            header: 'Org Name',
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: '3' as any, // Component
            header: 'Component',
            enableSorting: true,
            enableFiltering: true,
            filterVariant: 'multi-select',
        },
        {
            accessorKey: '4' as any, // Product Line
            header: 'Product Line',
            enableSorting: true,
            enableFiltering: true,
            filterVariant: 'multi-select',
            filterSelectOptions: ['Commercial', 'Medicaid', 'Medicare', 'Exchange'],
        },
        {
            accessorKey: '6' as any, // Reporting Product
            header: 'Reporting Product',
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: '7' as any, // Special Project
            header: 'Special Project',
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: '8' as any, // Special Area
            header: 'Special Area',
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: '9' as any, // CMS Contract
            header: 'CMS Contract',
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: '10' as any, // Reporting Unit Id
            header: 'Reporting Unit Id',
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: '11' as any, // Received
            header: 'Received',
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: '12' as any, // Stage
            header: 'Stage',
            enableSorting: true,
            enableFiltering: true,
            filterVariant: 'multi-select',
        },
    ];

    public render() {
        if (this.state.redirect) {
            return this.redirectToErrorPage();
        }
        const { classes } = this.props;
        const open = Boolean(this.state.anchorEl);

        return (
            <Grid container alignItems="flex-end" spacing={2} className={classes.mainPanel + " " + classes.root}>
                <Grid size={3}>
                    <Typography className={classes.submissionTitle}>
                        Submissions
                    </Typography>
                </Grid>
                <Grid size={6} alignItems="flex-end">
                    <Link href="#" onClick={(e) => { this.setState({ openBulkDialog: true }) }}>
                        <i><u>Click Here for Bulk Reprocessing</u></i>
                    </Link>
                    <div>
                        <Dialog open={this.state.openBulkDialog} classes={{ paper: classes.dialogM }} >
                            <DialogTitle id="max-width-dialog-title">
                                Bulk Reprocessing Submissions
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                <Grid container spacing={2}>
                                    <Grid size={6} key="subBulkSubTypeGrid" className={classes.flexGrow + " " + classes.fullWidth}>
                                        <Box flexGrow={1} className={classes.defaultMargin}>
                                            <InputLabel shrink>Select Submission Type</InputLabel>
                                            <Select
                                                options={this.getSubmissionTypeOptions()}
                                                placeholder="Submission Type"
                                                value={this.state.bulkSelectedSubType}
                                                onChange={this.onChangeBulkSubmissionType.bind(this)}
                                                isSearchable={true}
                                                isClearable={true}
                                                menuPortalTarget={document.body}
                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid size={12} key="subBulkReprocessGrid" className={classes.flexGrow + " " + classes.fullWidth}>
                                        <Box flexGrow={1} className={classes.defaultMargin}>
                                            <TextField
                                                id="subIdsTf"
                                                label="SubmissionIds (csv string)"
                                                multiline
                                                rows={4}
                                                variant="outlined"
                                                className={classes.fullWidth}
                                                value={this.state.bulkSubmissionIds}
                                                onChange={this.onChangeBulkSubIds.bind(this)}
                                                error={!(/^[0-9,]*$/.test(this.state.bulkSubmissionIds))}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid size={12} className={classes.flexGrow + " " + classes.fullWidth}>
                                        {this.state.isBulkReprocessing ?
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <Typography className={classes.darkOrangeColor}>Reprocessing the submissions...</Typography>
                                                        </td>
                                                        <td>
                                                            <ProcessingDisplay completed={false} />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table> : null
                                        }
                                        {this.state.showBulkReprocessSuccess ?
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <Typography className={classes.greenColor}>Submissions reprocessed</Typography>
                                                        </td>
                                                        <td>
                                                            <ProcessingDisplay completed={true} />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table> : null
                                        }
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <Divider />
                            <DialogActions>
                                {this.state.showBulkReprocessSuccess ?
                                    <Button
                                        className={classes.disabledButton}
                                        onClick={() => this.setState({ bulkSubmissionIds: "", bulkSelectedSubType: "", showBulkReprocessSuccess: false, isBulkReprocessing: false })}
                                        disabled={false}
                                    >
                                        Reset
                                    </Button> :
                                    <Fab className={classes.fab} size="medium" variant="extended" color="secondary" onClick={this.onBulkReprocessingSubmit.bind(this)}
                                        disabled={this.state.bulkSubmissionIds === "" || this.state.bulkSelectedSubType === "" || !(/^[0-9,]*$/.test(this.state.bulkSubmissionIds)) || this.state.isBulkReprocessing}>
                                        <Autorenew className={classes.extendedIcon} />
                                        Reprocess
                                    </Fab>}
                                <Button
                                    className={classes.disabledButton}
                                    onClick={() => this.setState({ bulkSubmissionIds: "", bulkSelectedSubType: "", openBulkDialog: false })}
                                    disabled={false}
                                >
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                </Grid>
                <Grid size={3} alignItems="flex-end" style={{ textAlign: 'right' }}>
                    {this.renderActions(open)}
                </Grid>
                <Grid size={12}>
                    {this.state.isLoading ? (
                        <LoadingDataTable titleText="*" count={10}/>
                    ) : (
                        <Fade in={true} timeout={SeedTime}>
                            <div>
                                <SharedMaterialReactTable
                                    data={this.state.submissionData}
                                    columns={this.getSubmissionColumns()}
                                    isLoading={this.state.isLoading}
                                    enablePagination={true}
                                    enableSorting={true}
                                    enableFiltering={true}
                                    enableColumnActions={true}
                                    enableRowActions={false}
                                    enableRowSelection={true}
                                    enableMultiRowSelection={true}
                                    enableSelectAll={true}
                                    rowSelection={this.getSubmissionSelectionState()}
                                    getRowId={(row, index) => row[1] || index.toString()} // Sub ID as unique key
                                    onRowSelectionChange={(updatedSelection) => {
                                        const selectedIndexes = Object.keys(updatedSelection)
                                            .filter(key => updatedSelection[key])
                                            .map(key => {
                                                const subId = key;
                                                return this.state.submissionData.findIndex(
                                                    item => item[1]?.toString() === subId
                                                );
                                            })
                                            .filter(index => index !== -1);

                                        let selectedRows = [];
                                        selectedIndexes.forEach(index => {
                                            const dataRow = this.state.submissionData[index];
                                            selectedRows.push({
                                                submissionId: dataRow[1] || 0,
                                                productLine: dataRow[4] ? dataRow[4].toString() : "",
                                                component: dataRow[3] ? dataRow[3].toString() : "",
                                                stage: dataRow[12] ? dataRow[12].toString() : "",
                                            });
                                        });
                                        this.setState({
                                            selectedSubmissions: selectedRows,
                                            rowsSelected: selectedIndexes
                                        });
                                    }}
                                    initialState={{
                                        pagination: { pageIndex: 0, pageSize: 20 },
                                    }}
                                    muiPaginationProps={{
                                        rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100, 500, 1000],
                                    }}
                                    emptyMessage="No submissions found."
                                />
                                {this.renderActions(open)}
                            </div>
                        </Fade>
                    )}
                </Grid>
            </Grid>
        );
    }

    private async refreshModel() {
        this.setState({ isLoading: true });

        const retval = await firstValueFrom(
            SubmissionsService.GetSubmissionsForUser$(this.props.user, true)
        );

        if (retval instanceof AjaxError || !retval) {
            this.setRedirectState();
        } else {
            const submissionData: any[] = retval.map(item => {
                return [
                    item.orgId,
                    item.subId,
                    item.orgName,
                    item.component.replace("DST", "HEDIS"),
                    item.productLine,
                    item.validationStatus,
                    item.reportingProduct,
                    item.specialProject,
                    item.specialArea,
                    item.cmsContractNumber,
                    item.reportingUnitId,
                    item.received,
                    SharedUtility.GetStageCleanName(item.submissionStatus)
                ];
            });

            this.setState({
                submissionData: submissionData,
                isLoading: false
            });
        }
    }

    private onBulkReprocessingSubmit = async () => {
        this.setState({ isBulkReprocessing: true });
        const count = this.state.bulkSubmissionIds.split(',').length;
        let time = 8000;
        if (count < 8) {
            time = count * 1000;
        }

        const response = await firstValueFrom(
            SubmissionsService.BulkSubmissionActionByIdsStr$(
                this.props.user,
                this.state.bulkSubmissionIds,
                this.state.bulkSelectedSubType.value.replace("HEDIS", "DST"),
                REPROCESS
            )
        );

        if (response instanceof AjaxError || !response) {
            this.setRedirectState();
            this.setState({ isBulkReprocessing: false });
        } else {
            this.setState(
                { isBulkReprocessing: true },
                () =>
                    setTimeout(() => {
                        this.setState({
                            isBulkReprocessing: false,
                            showBulkReprocessSuccess: true
                        });
                    }, time)
            );
        }
    }

    private onChangeBulkSubIds(e) {
        this.setState({ bulkSubmissionIds: e.target.value });
    }
    private onChangeBulkSubmissionType(newValue) {
        this.setState({
            bulkSelectedSubType: newValue === null ? "" : newValue,
        });
    }

    private getSubmissionTypeOptions() {
        return [
            { value: "HEDIS", label: "HEDIS" },
            { value: "AdultCAHPS", label: "AdultCAHPS" },
            { value: "ChildCAHPS", label: "ChildCAHPS" },
            { value: "ChildCAHPSCCC", label: "ChildCAHPSCCC" },
            { value: "HOS", label: "HOS" }
        ];
    }
    private handleButtonMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        this.setState({ anchorEl: event.currentTarget });
    }

    private closeDialog() {
        this.setState({ openDialog: false });
        this.setSelectedActionState();
    }

    private handleButtonMenuClose = (action, event) => {

        var selectedSubmissions = this.state.selectedSubmissions;

        if (typeof action === 'string') {
            this.setSelectedActionState(action);
        }
        else {
            this.setSelectedActionState(null);
        }

        //validate selected options
        if (!this.validate(action, selectedSubmissions)) {
            return false;
        }

        //show confirmation dialog    
        this.setState({ openDialog: true, dialogConfirmationText: `Are you sure you want to perform the ${action} action?` });
    }

    private validate = (action, selectedSubmissions: ISelectedSubmissions[]): boolean => {
        this.getSelectedSubmissionDetails(selectedSubmissions);

        //1. check at least one submission is selected
        if (selectedSubmissions.length === 0) {
            this.setSelectedActionState();
            this.setStatusMessageState("Please select a submission");
            return false;
        }

        //2. check for multiple components       
        if (distinctComponents.length > 1) {
            this.setSelectedActionState();
            this.setStatusMessageState("Please select only one submission component type at a time");
            return false;
        }

        //3. check for multiple stages
        if (distinctStages.length > 1) {
            this.setSelectedActionState();
            this.setStatusMessageState("Please select only one submission stage at a time");
            return false;
        }

        var selectedComponent = distinctComponents[0];
        var selectedStage = distinctStages[0];
        var errorText = `${action} action cannot be performed for the selected stage ("${selectedStage}")`;

        //4. validate Unattest for CAHPS
        var defaultReturn = false;
        if (action === REPROCESS) {
            defaultReturn = true;
        }
        else if (action === UNATTEST) {
            defaultReturn = true;
            if (selectedComponent.includes(CAHPS)) {
                this.setSelectedActionState();
                this.setStatusMessageState(`This action ("${action}") is not applicable for CAHPS submissions`);
                return false;
            }
            else if ((selectedComponent === HEDIS && selectedStage !== "Complete") ||
                (selectedComponent === HOS && selectedStage !== "Apply Mark Final")) {
                this.setActionAndErrorMessage(errorText);
                return false;
            }
        } else if (action === UNSUBMIT) { //5. validate Unsubmit & selected stage
            defaultReturn = true;
            if ((selectedComponent.includes(CAHPS) && selectedStage !== "Apply Mark Final") ||
                (selectedComponent === HEDIS && selectedStage !== "Apply Plan Lock") ||
                (selectedComponent === HOS && selectedStage !== "Validations/Attestation")) {
                this.setActionAndErrorMessage(errorText);
                return false;
            }
        } else if (action === ROLLBACK && selectedStage !== "Complete") { //6. validate Rollback & selected stage
            defaultReturn = true;
            this.setActionAndErrorMessage(errorText);
            return false;
        } else if (action === UNMARKFINAL) { // //7. validate Unmarkfinal & selected stage
            defaultReturn = true;
            if (((selectedComponent.includes(CAHPS) || selectedComponent === HOS) && (selectedStage !== "Complete" && selectedStage !== "Finalize Attestation")) ||
                (selectedComponent === HEDIS && selectedStage !== "Finalize Attestation")) {
                this.setActionAndErrorMessage(errorText);
                return false;
            }
        }
        return defaultReturn;
    }

    private getSelectedSubmissionDetails = (selectedSubmissions: ISelectedSubmissions[]) => {
        //get distinct components
        distinctComponents = [...new Set(selectedSubmissions.map(sub => sub.component))]
        //get distinct stages
        distinctStages = [...new Set(selectedSubmissions.map(sub => sub.stage))];
        //get distinct subids
        distinctSubIds = [...new Set(selectedSubmissions.map(sub => sub.submissionId))];
    }

    private handleBulkSubmissionAction = async () => {
        const action = this.state.selectedAction;
        let selectedComponent = distinctComponents[0];

        if (selectedComponent === HEDIS) selectedComponent = "DST";

        this.setState({ isProcessing: true });

        const retval = await firstValueFrom(
            SubmissionsService.BulkSubmissionAction$(
                this.props.user,
                distinctSubIds,
                selectedComponent,
                action
            )
        );

        if (retval instanceof AjaxError || !retval) {
            this.setRedirectState();
            this.setPostProcessingState();
        } else {
            this.setPostProcessingState();
            this.setActionAndErrorMessage();
            this.setState({
                rowsSelected: [],
                selectedSubmissions: [],
                submissionData: []
            });
            this.refreshModel();
        }
    }

    private setActionAndErrorMessage = (message = null) => {
        this.setSelectedActionState();
        this.setStatusMessageState(message);
    }

    private setSelectedActionState = (action = null) => {
        this.setState({ anchorEl: null, selectedAction: action ?? "Available Actions" });
    }

    private setStatusMessageState = (message = null) => {
        this.setState({ statusMessage: message ?? "" });
    }

    private setPostProcessingState = () => {
        this.setState({ isProcessing: false, openDialog: false });
    }

    private renderActions = (open: boolean) => {
        const { classes } = this.props;
        return (

            <div className={classes.mt2 + ' ' + classes.mb2} style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant='body1' color='secondary'>
                    {this.state.statusMessage}
                </Typography>
                <span>
                    {this.state.isProcessing ? <span style={{ paddingTop: '20px' }}><CircularProgress color="primary" size={22} /></span> : null}
                    <Button
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        variant="contained"
                        onClick={this.handleButtonMenuClick}
                        color="primary"
                    >
                        {this.state.selectedAction}  <ArrowDropDownIcon />
                    </Button>
                    <Menu
                        id="long-menu"
                        anchorEl={this.state.anchorEl}
                        keepMounted
                        open={open}
                        onClose={this.handleButtonMenuClose}
                        PaperProps={{
                            style: {
                                maxHeight: ITEM_HEIGHT * 4.5,
                                width: 150,
                            },
                        }}
                    >
                        {SubmissionActions.map(item => (
                            <MenuItem key={item.Action} onClick={event => this.handleButtonMenuClose(item.Action, event)}>
                                {item.Action}
                            </MenuItem>
                        ))}
                    </Menu>
                </span>
                <Dialog
                    open={this.state.openDialog}
                    onClose={this.closeDialog.bind(this)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">
                        {this.state.dialogConfirmationText}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">

                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.handleBulkSubmissionAction.bind(this)}
                            color="primary"
                            autoFocus>
                            Yes
                        </Button>
                        <Button
                            onClick={this.closeDialog.bind(this)}
                            color="primary">
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

// REDUX CONTAINER
const SubmissionAdministrationPageWithState = connect<IGenericUserProps>(
    genericMapStateToProps
)(SubmissionAdministrationView);

// STYLES CONTAINER
const SubmissionAdministrationPage = withStyles(styles)(
    SubmissionAdministrationPageWithState
);

export default SubmissionAdministrationPage;
